import { render, staticRenderFns } from "./StoreInfoFront.vue?vue&type=template&id=3d5452c9&scoped=true"
import script from "./StoreInfoFront.vue?vue&type=script&lang=js"
export * from "./StoreInfoFront.vue?vue&type=script&lang=js"
import style0 from "./StoreInfoFront.vue?vue&type=style&index=0&id=3d5452c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5452c9",
  null
  
)

export default component.exports